import merge from "deepmerge";
import { produce } from "immer";

import types from './types';
import module_modals_data from './module_modals_data';
import modals_data from './modals_data';

const updateModuleModalsDetails = (state, path, data) => produce(state, draft => {
    const parts = path.split('.');
    const key = parts.pop();

    let current = draft.module_modals_data;

    for (const p of parts) {
        if (!current[p]) return;
        current = current[p];
    }

    current[key] = merge(current[key] || {}, data);
});

const updateModalsDetails = (state, path, data) => produce(state, draft => {
    const parts = path.split('.');
    const key = parts.pop();

    let current = draft.modals_data;

    for (const p of parts) {
        if (!current[p]) return;
        current = current[p];
    }

    current[key] = merge(current[key] || {}, data);
});

const InitialState = {
    loaded: false,

    // Modals
    modals: [],
    modals_data: {},

    // Module Modals
    module_modals: [],
    module_modals_data: {},

    // Popups
    popups: []
} 

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.module_modals.update:
            return {
                ...state,
                ...updateModuleModalsDetails(state, payload.path, payload.data)
            }
        case types.module_modals.show:
            const modal = state.module_modals.filter(m => m.key == payload.key && m.triggerId === payload.triggerId)[0] || null;

            return modal ? {
                ...state,
                module_modals: state.module_modals.map(m => {
                    return (m.key == payload.key && m.triggerId === payload.triggerId) ? {
                        ...m,
                        visible: true,
                        visible_at: Date.now()
                    } : m;
                }),
                module_modals_data: {
                    ...state.module_modals_data,
                    [payload.key]: module_modals_data[payload.key]
                }
            } : state;
        case types.module_modals.close:
            return {
                ...state,
                module_modals: state.module_modals.filter(m => m.triggerId !== payload)
            }

        case types.modals.update:
            return {
                ...state,
                ...updateModalsDetails(state, payload.path, payload.data)
            }
        case types.modals.close:
            return {
                ...state,
                modals: state.modals.filter(m => m !== payload)
            }
        case types.modals.show:
            return {
                ...state,
                modals: [
                    ...state.modals,
                    payload
                ],
                modals_data: {
                    ...state.modals_data,
                    [payload]: modals_data[payload]
                }
            };
        case types.loaded:
            return {
                ...state,
                loaded: true,
                module_modals: payload.module_modals
            }
        default:
            return state;
    }
}